export enum ActionTypesGlobal {
   WISHLIST = 'wishlist',
   CARTLIST = 'cartList',
   UPDATE_FINAL_VALUE = 'updateFinalValue'
}